var __TEMP__ = require('./_Stack.js');var Stack = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_assignMergeValue.js');var assignMergeValue = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseFor.js');var baseFor = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_baseMergeDeep.js');var baseMergeDeep = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isObject.js');var isObject = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./keysIn.js');var keysIn = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_safeGet.js');var safeGet = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseMerge;
